package com.trevorwiebe.timesheet.settlements.presentation

import com.trevorwiebe.timesheet.settlements.domain.model.SettlementCharge
import kotlinx.datetime.LocalDate

sealed class SettlementsEvent {
    data class OnSelectTab(val tab: SettlementListTab) : SettlementsEvent()

    data object OnNewSettlementClick : SettlementsEvent()
    data object OnDismissNewSettlement : SettlementsEvent()
    data class OnSelectOwnerOperator(val ownerOperatorId: String) : SettlementsEvent()
    data class OnSelectCarrier(val carrierId: String) : SettlementsEvent()
    data object OnStartDateClick : SettlementsEvent()
    data object OnEndDateClick : SettlementsEvent()
    data class OnStartDateSelected(val date: LocalDate?) : SettlementsEvent()
    data class OnEndDateSelected(val date: LocalDate) : SettlementsEvent()
    data object OnDismissDatePickers : SettlementsEvent()
    data class OnToggleLoad(val loadId: String) : SettlementsEvent()
    data object OnSelectAllLoads : SettlementsEvent()
    data object OnClearLoadSelection : SettlementsEvent()
    data object OnCreateSettlement : SettlementsEvent()

    data class OnSettlementClick(val settlementId: String) : SettlementsEvent()
    data object OnCloseSettlement : SettlementsEvent()
    data object OnRequestDelete : SettlementsEvent()
    data object OnDismissDelete : SettlementsEvent()
    data object OnConfirmDelete : SettlementsEvent()
    data object OnRequestMarkSent : SettlementsEvent()
    data object OnDismissMarkSent : SettlementsEvent()
    data object OnConfirmMarkSent : SettlementsEvent()

    data class OnLineClick(val loadId: String) : SettlementsEvent()
    data class OnLineBasePercentChanged(val text: String) : SettlementsEvent()
    data class OnLinePercentChanged(val charge: SettlementCharge, val text: String) : SettlementsEvent()
    data object OnDismissLineDialog : SettlementsEvent()
    data object OnSaveLinePercent : SettlementsEvent()

    data object OnAddDeductionClick : SettlementsEvent()
    data class OnDeductionClick(val index: Int) : SettlementsEvent()
    data class OnDeductionDescriptionChanged(val text: String) : SettlementsEvent()
    data class OnDeductionAmountChanged(val text: String) : SettlementsEvent()
    data object OnDismissDeduction : SettlementsEvent()
    data object OnSaveDeduction : SettlementsEvent()
    data object OnDeleteDeduction : SettlementsEvent()

    data object OnViewPdfClick : SettlementsEvent()
    data object OnPdfOpened : SettlementsEvent()
    data object OnSendClick : SettlementsEvent()
    data class OnSendRecipientChanged(val text: String) : SettlementsEvent()
    data object OnDismissSend : SettlementsEvent()
    data object OnConfirmSend : SettlementsEvent()

    data object OnInfoShown : SettlementsEvent()
    data object OnErrorShown : SettlementsEvent()
}
